// import React from 'react';
import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, []);
  const regeneratePaymentFolio = `regeneratePaymentFolio(input: ${dataCreate})`;
  return gql`
  mutation {
    ${regeneratePaymentFolio} {
      id
    }
  }
`;
};
